import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export type MoviefoneRiskTolerance = 'low' | 'medium' | 'high';

/** Client-side-only trade card filters that have no `StructureRequest` equivalent. */
export interface MoviefoneTradeFilters {
  riskTolerance: MoviefoneRiskTolerance;
  max_pnl_ratio: number;
}

export const moviefoneTradeFiltersState = atom<MoviefoneTradeFilters>({
  key: 'moviefone-tradeFiltersState',
  default: {
    riskTolerance: 'medium',
    max_pnl_ratio: Infinity,
  },
  effects_UNSTABLE: [persistAtom],
});

export interface MoviefoneNotes {
  gatekeeperModel: string;
  gatekeeperPrompt?: string;
  primaryModel: string;
  primaryPrompt?: string;
  dirty: boolean;
}

export const moviefoneNotesState = atom<MoviefoneNotes>({
  key: 'moviefone-notes',
  default: {
    gatekeeperModel: 'openai.gpt-oss-20b',
    primaryModel: 'openai.gpt-oss-120b',
    dirty: false,
  },
});
